import { Slide } from "@jelly/lesson";
import theory from "../../theory";

const principle: Slide = {
  title: "Main categories of acoustic simulation methods",
  theory: theory,
  layout: {
    type: "custom030101",
    options: {},
  },
};

export default principle;
